import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

// Services
import { MessageServiceBroker } from '../message.service';
import { RouteParam, ServiceBase } from '../service-base';

// Modèles
import { GeneralFactory } from 'src/app/@shared/models/factories/general-factory';
import { TgcDeclarationFieldInvoice } from 'src/app/@shared/models/taxation/tgc-declaration-field-invoice.model';

// Utilitaires API
import { ODataListResponse } from 'src/app/@shared/utilities/odata/response';

const CLASS_NAME = 'TgcDeclaration';
const ENDPOINT = `/tgc-declarations/`;

const ROUTES: RouteParam[] = [
    { key: 'downloadFile', path: '{id}/xml/' },
    { key: 'fieldInvoices', path: '{id}/field-invoices/' },
    { key: 'validate', path: '{id}/validate/' },
]

@Injectable({
    providedIn: 'root'
})
export class TgcDeclarationService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addRoutes(ROUTES);
    }

    public getFieldInvoices$(declarationId: number, field: string): Observable<TgcDeclarationFieldInvoice[]> {
        const url = this.routes.fieldInvoices.replace('{id}', declarationId.toString());
        const params = new HttpParams().set('field', field);
        this._fetching$.next(true);
        return this.httpClient.get(url, { params }).pipe(
            finalize(() => this._fetching$.next(false)),
            map((json: any) => {
                const response = new ODataListResponse(json);
                return response.results.map(
                    (item: any) => GeneralFactory.get('TgcDeclarationFieldInvoice', item) as TgcDeclarationFieldInvoice
                );
            }),
            catchError((error: any) => {
                try { this.handleError(error); } catch (_) { }
                return of([]);
            })
        );
    }
}
